import { Link } from "@mui/material";
import { forwardRef, type ReactNode } from "react";

import { type MuiLinkProps } from "../types";

export interface ExternalLinkProps extends Omit<MuiLinkProps, "href"> {
  to: string;
  children: ReactNode;
}

/**
 * @deprecated Use the TextButton component from cbh-mobile-app's redesign system to show links instead.
 * ui-components has been removed from cbh-core.
 * Link redirection logic should be handled by the specific application that consumes this component.
 */
export const ExternalLink = forwardRef<HTMLAnchorElement, ExternalLinkProps>((props, ref) => {
  const { to, children, ...rest } = props;
  return (
    <Link ref={ref} href={to} {...rest} target="_blank" rel="noopener noreferrer">
      {children}
    </Link>
  );
});

ExternalLink.displayName = "ExternalLink";
